import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionBar = ({ 
  selectedCount, 
  onSelectAll, 
  onDeselectAll, 
  onBulkDelete, 
  onBulkExport, 
  onBulkCategorize,
  totalCount 
}) => {
  const [showActions, setShowActions] = useState(false);
  const [bulkCategory, setBulkCategory] = useState('');

  const categoryOptions = [
    { value: 'marketing', label: 'Marketing' },
    { value: 'legal', label: 'Legal' },
    { value: 'technical', label: 'Technical' },
    { value: 'creative', label: 'Creative' },
    { value: 'business', label: 'Business' }
  ];

  const handleBulkCategorize = () => {
    if (bulkCategory) {
      onBulkCategorize(bulkCategory);
      setBulkCategory('');
      setShowActions(false);
    }
  };

  const handleBulkDelete = () => {
    if (window.confirm(`Are you sure you want to delete ${selectedCount} selected prompts? This action cannot be undone.`)) {
      onBulkDelete();
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="bg-primary/5 border border-primary/20 rounded-lg p-4 mb-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={20} color="var(--color-primary)" />
            <span className="font-medium text-text-primary">
              {selectedCount} of {totalCount} selected
            </span>
          </div>
          
          <div className="flex items-center space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={selectedCount === totalCount ? onDeselectAll : onSelectAll}
              iconName={selectedCount === totalCount ? "Square" : "CheckSquare"}
              iconSize={14}
            >
              {selectedCount === totalCount ? 'Deselect All' : 'Select All'}
            </Button>
          </div>
        </div>

        <div className="flex items-center space-x-2">
          {/* Desktop Actions */}
          <div className="hidden md:flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onBulkExport}
              iconName="Download"
              iconSize={14}
            >
              Export
            </Button>
            
            <div className="flex items-center space-x-2">
              <Select
                options={categoryOptions}
                value={bulkCategory}
                onChange={setBulkCategory}
                placeholder="Change category"
                className="w-40"
              />
              <Button
                variant="outline"
                size="sm"
                onClick={handleBulkCategorize}
                disabled={!bulkCategory}
                iconName="Tag"
                iconSize={14}
              >
                Apply
              </Button>
            </div>
            
            <Button
              variant="destructive"
              size="sm"
              onClick={handleBulkDelete}
              iconName="Trash2"
              iconSize={14}
            >
              Delete
            </Button>
          </div>

          {/* Mobile Actions */}
          <div className="md:hidden">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setShowActions(!showActions)}
              iconName="MoreVertical"
              iconSize={16}
            >
              Actions
            </Button>
          </div>
        </div>
      </div>

      {/* Mobile Action Panel */}
      {showActions && (
        <div className="md:hidden mt-4 pt-4 border-t border-border space-y-3">
          <Button
            variant="outline"
            size="sm"
            onClick={onBulkExport}
            iconName="Download"
            iconSize={14}
            fullWidth
          >
            Export Selected
          </Button>
          
          <div className="space-y-2">
            <Select
              label="Change Category"
              options={categoryOptions}
              value={bulkCategory}
              onChange={setBulkCategory}
              placeholder="Select new category"
            />
            <Button
              variant="outline"
              size="sm"
              onClick={handleBulkCategorize}
              disabled={!bulkCategory}
              iconName="Tag"
              iconSize={14}
              fullWidth
            >
              Apply Category
            </Button>
          </div>
          
          <Button
            variant="destructive"
            size="sm"
            onClick={handleBulkDelete}
            iconName="Trash2"
            iconSize={14}
            fullWidth
          >
            Delete Selected
          </Button>
        </div>
      )}
    </div>
  );
};

export default BulkActionBar;